"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(3) / 2,
      width: 140,
      height: 140,
      cursor: 'pointer'
    },
    image: {
      width: 70,
      height: 'auto'
    },
    title: {
      fontSize: '0.875rem',
      textAlign: 'center'
    }
  };
};

var _default = styles;
exports.default = _default;